import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  isMenuOpen = false;

  toggleMenu(state?: boolean): void {
    this.isMenuOpen = state !== undefined ? state : !this.isMenuOpen;
  }
}
